import { Route } from '@angular/router';

export const PrescriptionsStandaloneRoute: Route = {
  path: '',
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/prescriptions_shell'
    ).then((c) => c.PrescriptionsShellStandaloneRoutes);
  },
};
